import { Component, ElementRef, OnInit, ViewChild, ViewEncapsulation } from "@angular/core";
import { KYMW00Model } from "src/app/commons/kymw00/kymw00.model";
import { PlessDialogServiceSub } from "src/app/commons/kymw00/pless-dialog-service-sub";
import { PlessViewHelperSub } from "src/app/commons/kymw00/pless-view-helper-sub";
import { PlessViewUtilsSub } from "src/app/commons/kymw00/pless-view-utils-sub.service";
import { KYMW1708Model } from "./kymw1708.model";
import { GetPastImageInfoResponse, GetPastImageInfoService } from "../kymw1705/api-services/get-past-image-info.service";
import { RegistMultipleCodeImageInfoService } from "./api-services/regist-multiple-code-image-info.service";

/**
 * 複数コード登録画面を管理するクラス
 * 
 * @export KYMW1708Component
 * @class KYMW1708Component
 */
@Component({
  selector: 'app-kymw1708',
  templateUrl: 'kymw1708.component.html',
  styleUrls: ['kymw1708.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW1708Component extends PlessViewHelperSub implements OnInit{
  kymw1708Model: KYMW1708Model = new KYMW1708Model();
  constructor(
    private kymw00Model: KYMW00Model,
    private dialogService: PlessDialogServiceSub,
    private getPastImageInfoService: GetPastImageInfoService,
    private registMultipleCodeImageInfoService: RegistMultipleCodeImageInfoService,
  ){
    super(kymw00Model)
  }

  @ViewChild('txti_ImageFileName', { static: true }) txti_ImageFileName: ElementRef;

  /**
   * 親画面から値を受け取る
   * @param param 画像ID
   */
  setParameter(param) {
    this.kymw1708Model.callerImageId = param;
  }  

  /**
   * 初期処理
   * 
   */
  ngOnInit(): void {
    this.componentName = 'KYMW1708';
    this.kymw1708Model.kymw1708Component = this;
  }

  /**
   * 表示ボタン押下時
   * 
   */
  public eventDisplay_CLICKHandler() {
    // 画像ファイル名の必須チェック・属性チェック
    if ( PlessViewUtilsSub.isEmpty(this.kymw1708Model.imageFileName) ) {
      this.dialogService.openAlertGetMessage('W0001', ['画像ファイル名']);
      return;
    }
    this.getPastImageInfoService.execute(this.kymw1708Model.imageFileName, (data: GetPastImageInfoResponse) => {
      this.kymw1708Model.imageId = data.ImageId;
      this.kymw1708Model.imagePreviewUrl = data.ImagePreviewUrl
    });
  }

  /**
   * 画像サイズを設定
   * @memberof KYMW1705Component
   */
  public setImageScale():void {
    const img = document.getElementById('img_MultiCode') as HTMLImageElement;

    if (img.naturalHeight < 650 && img.naturalWidth < 650) {
      // 画像を縦横どちらかは650にあわせる
      const ratio = img.naturalHeight / img.naturalWidth;
      // 横長画像のとき
      if ( img.naturalHeight < img.naturalWidth ) {
        img.width = 650;
        img.height = img.naturalWidth / ratio;
      } else {
        // 縦長画像のとき
        img.width = img.naturalHeight * ratio;
        img.height = 650;
      }
    }
  }

  /**
   * 登録ボタン押下時
   * 
   */
  public eventRegist_CLICKHandler() {
    // 画像が未表示の場合、過去画像が表示されていない旨のメッセージを表示する
    if (PlessViewUtilsSub.isEmpty(this.kymw1708Model.imagePreviewUrl)) {
      this.dialogService.openAlertGetMessage('E0549');
      return;
    }
    // 過去画像登録API実行
    this.registMultipleCodeImageInfoService.execute(this.kymw1708Model, () => {
      this.dialogService.openAlertGetMessage('I0106', ['登録が完了']);
      this.onClickClose(true);
    });
  }

  onClickClose(refreshDisplay: boolean = false) {
    this.closeFunction(refreshDisplay);
  }

  /**
   * 画像ファイル名の入力から半角カンマを削除
   */
  public eventImageFileName_deleteCommaHandler(e: Event): void {
    this.kymw1708Model.imageFileName = this.kymw1708Model.imageFileName.replace(/,/g, '');
    // 画面に反映
    this.txti_ImageFileName.nativeElement.value = this.kymw1708Model.imageFileName;
  }
}
